import { render, staticRenderFns } from "./NewPaymentFormFinal.vue?vue&type=template&id=237ba986&scoped=true&"
import script from "./NewPaymentFormFinal.vue?vue&type=script&lang=js&"
export * from "./NewPaymentFormFinal.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymentFormFinal.vue?vue&type=style&index=0&id=237ba986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ba986",
  null
  
)

export default component.exports